import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { LifeBuoy, ArrowLeft } from 'lucide-react';
import logo from '../assets/logo.png';
import SupportThread from '../components/SupportThread';

export default function SupportThreadPage() {
  const { token } = useParams();
  return (
    <div className="min-h-screen bg-gradient-to-br from-charcoal-50 via-white to-cmic-50 py-10 px-4" data-testid="support-thread-page">
      <div className="max-w-2xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <img src={logo} alt="CMIC" className="h-10" />
          <Link to="/login" className="inline-flex items-center gap-1.5 text-sm text-charcoal-500 hover:text-cmic-700">
            <ArrowLeft size={15} /> Inicio de sesión
          </Link>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="px-6 py-5 border-b border-gray-100">
            <h1 className="text-xl font-bold text-charcoal-900 flex items-center gap-2">
              <LifeBuoy size={22} className="text-cmic-600" /> Conversación con soporte
            </h1>
            <p className="text-sm text-charcoal-500 mt-1">Escríbenos aquí. Te responderemos lo antes posible.</p>
          </div>
          <div className="p-6">
            <SupportThread token={token} />
          </div>
        </div>
      </div>
    </div>
  );
}
